import { render, staticRenderFns } from "./OnboardingGuide.vue?vue&type=template&id=d64cb21c&scoped=true&"
import script from "./OnboardingGuide.vue?vue&type=script&lang=js&"
export * from "./OnboardingGuide.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingGuide.vue?vue&type=style&index=0&id=d64cb21c&prod&lang=scss&"
import style1 from "./OnboardingGuide.vue?vue&type=style&index=1&id=d64cb21c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64cb21c",
  null
  
)

export default component.exports